<template>
  <v-select 
    :options="internalOptions"
    :clearable="false"
    :filterable="false"
    :searchable="false"
    :multiple="multiple"
    :value="getOptions(query)"
    :placeholder="placeholder"
    @input="onChange"
  >
  </v-select>
</template>
<script>
import Vue from "vue";
import { VueDataTablesFiltersMixin } from "vue-datatables.net";

export default Vue.extend({
  mixins: [VueDataTablesFiltersMixin],
  name: 'DatatablesFilterSelect',
  props: {
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean
    },
    addEmpty: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String
    }
  },
  methods: {
    onChange(data) { 
      this.query = Array.isArray(data) ? 
        data.map(d => d.value).join(',') : 
        data.value; 
    },
    getOptions(value) {
      if (this.internalOptions.some(io => io.label === "Cardiometabolic Risk Assessment")) {
        return this.internalOptions.filter(
          option => value === option.value);
      }

      return this.internalOptions.filter(
        option => value.toString().split(',').includes(option.value.toString())
      );
    }
  },
  computed: {
    internalOptions() {
      let options = this.options;

      if (this.addEmpty) {
        options = [{ text: "Any", value: "" }, ...options];
      }
      
      return options.map(option => ({ 
        label: option.text, 
        value: option.value
      }));
    }
  }
});
</script>
